import { CommonModule } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ToastrModule } from 'ngx-toastr';

import { BackgroundBrandedModule } from './modules/background-branded/background-branded.module';
import { CharacterCounterModule } from './modules/character-counter/character-counter.module';
import { CordovaModule } from './modules/cordova/cordova.module';
import { CrowdinLoaderModule } from './modules/crowdin-loader/crowdin-loader.module';
import { IconsModule } from './modules/icons/icon.module';
import { LogoModule } from './modules/logo/logo.module';
import { NavigateBackModule } from './modules/navigate-back/navigate-back.module';
import { RecaptchaModule } from './modules/recaptcha/recaptcha.module';
import { RoutingRootViewModule } from './modules/routing-root-view/routing-root-view.module';
import { TranslateModule } from './modules/translate/translate.module';
import { WaitForImageModule } from './modules/wait-for-image/wait-for-image.module';
import { ToastrModuleConfig } from './services/toasts.service';

@NgModule({
  exports: [
    BackgroundBrandedModule,
    CharacterCounterModule,
    CommonModule,
    IconsModule,
    LogoModule,
    NavigateBackModule,
    RecaptchaModule,
    RoutingRootViewModule,
    TranslateModule,
    ToastrModule,
    WaitForImageModule
  ],
  imports: [
    BackgroundBrandedModule,
    CharacterCounterModule,
    CrowdinLoaderModule,
    ClipboardModule,
    CommonModule,
    CordovaModule,
    IconsModule,
    LogoModule,
    NavigateBackModule,
    RecaptchaModule,
    RoutingRootViewModule,
    TranslateModule,
    ToastrModule.forRoot(ToastrModuleConfig),
    WaitForImageModule
  ],
  providers: [{ provide: 'Window', useValue: window }, provideHttpClient()]
})
export class SharedModule {}
